import React from "react";
import { clsx } from "clsx";
import { PROSPECT_BILLING_ANNUAL, PROSPECT_BILLING_MONTHLY } from "util/prospectBilling";
import styles from "./prospectBillingToggle.module.scss";

export default function ProspectBillingToggle({ billingCycle, onChange, t }) {
  const isAnnual = billingCycle === PROSPECT_BILLING_ANNUAL;

  return (
    <div className={styles["prospect-billing-toggle"]} role="group" aria-label={t("sonic_prospect.billing_toggle_aria")}>
      <div className={styles["prospect-billing-toggle__row"]}>
        <button
          type="button"
          className={clsx(styles["prospect-billing-toggle__btn"], !isAnnual && styles["prospect-billing-toggle__btn--active"])}
          onClick={() => onChange(PROSPECT_BILLING_MONTHLY)}
        >
          {t("sonic_prospect.billing_monthly")}
        </button>
        <div className={styles["prospect-billing-toggle__yearly"]}>
          <button
            type="button"
            className={clsx(styles["prospect-billing-toggle__btn"], isAnnual && styles["prospect-billing-toggle__btn--active"])}
            onClick={() => onChange(PROSPECT_BILLING_ANNUAL)}
          >
            {t("sonic_prospect.billing_yearly")}
          </button>
          <span className={styles["prospect-billing-toggle__save"]}>{t("sonic_prospect.billing_save_two_months")}</span>
        </div>
      </div>
    </div>
  );
}
